import { writable } from 'svelte-local-storage-store';
export const playSoundStore = writable('sound', true);
